import { useEffect, useState } from "react";
import { navSections } from "@/mocks/home";

export default function SectionNav() {
  const [active, setActive] = useState("home");

  useEffect(() => {
    const sections = navSections
      .map((s) => document.getElementById(s.id))
      .filter((el): el is HTMLElement => Boolean(el));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: "-45% 0px -45% 0px", threshold: 0 },
    );

    sections.forEach((s) => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  return (
    <nav
      className="hidden xl:flex fixed right-6 top-1/2 -translate-y-1/2 z-40 flex-col items-end gap-5"
      aria-label="Section navigation"
    >
      {navSections.map((item) => {
        const isActive = active === item.id;
        return (
          <a
            key={item.id}
            href={`#${item.id}`}
            className="group flex items-center gap-3 cursor-pointer"
            aria-current={isActive ? "true" : undefined}
          >
            <span
              className={`text-[11px] uppercase tracking-[0.22em] transition-all duration-300 ${
                isActive
                  ? "opacity-100 text-foreground-800 translate-x-0"
                  : "opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 text-foreground-600"
              }`}
            >
              {item.label}
            </span>
            <span
              className={`block rounded-full border transition-all duration-300 ${
                isActive
                  ? "w-3 h-3 bg-primary-600 border-primary-600"
                  : "w-2.5 h-2.5 bg-transparent border-foreground-400 group-hover:border-primary-500"
              }`}
            />
          </a>
        );
      })}
    </nav>
  );
}